import { defineMessages } from 'react-intl-next';
export const shortcutMessages = defineMessages({
  'whiteboards.shortcuts.verbose.control.do-not-translate': {
    id: 'whiteboards.shortcuts.verbose.control.do-not-translate',
    defaultMessage: 'Control',
    description: 'The unabbreviated name of the Control key on a keyboard',
  },
  'whiteboards.shortcuts.verbose.shift.do-not-translate': {
    id: 'whiteboards.shortcuts.verbose.shift.do-not-translate',
    defaultMessage: 'Shift',
    description: 'The unabbreviated name of the Shift key on a keyboard',
  },
  'whiteboards.shortcuts.verbose.command.do-not-translate': {
    id: 'whiteboards.shortcuts.verbose.command.do-not-translate',
    defaultMessage: 'Command',
    description: 'The unabbreviated name of the Command key on a mac keyboard',
  },
  'whiteboards.shortcuts.verbose.option.do-not-translate': {
    id: 'whiteboards.shortcuts.verbose.option.do-not-translate',
    defaultMessage: 'Option',
    description: 'The unabbreviated name of the Option key on a mac keyboard',
  },
  'whiteboards.shortcuts.verbose.alt.do-not-translate': {
    id: 'whiteboards.shortcuts.verbose.alt.do-not-translate',
    defaultMessage: 'Alt',
    description: 'The unabbreviated name of the Alt key on a keyboard',
  },
  'whiteboards.shortcuts.short.ctrl.do-not-translate': {
    id: 'whiteboards.shortcuts.short.ctrl.do-not-translate',
    defaultMessage: 'Ctrl',
    description: 'The abbreviated name of the Control key on a keyboard',
  },
  'whiteboards.shortcuts.short.alt.do-not-translate': {
    id: 'whiteboards.shortcuts.short.alt.do-not-translate',
    defaultMessage: 'Alt',
    description: 'The abbreviated name of the Alt key on a keyboard',
  },
  'whiteboards.shortcuts.short.cmd.do-not-translate': {
    id: 'whiteboards.shortcuts.short.cmd.do-not-translate',
    defaultMessage: '⌘',
    description: 'The abbreviated symbol for the Command key on a mac keyboard.',
  },
  'whiteboards.shortcuts.short.option.do-not-translate': {
    id: 'whiteboards.shortcuts.short.option.do-not-translate',
    defaultMessage: '⌥',
    description: 'The abbreviated symbol for the Option key on a mac keyboard.',
  },
  'whiteboards.shortcuts.short.shift.do-not-translate': {
    id: 'whiteboards.shortcuts.short.shift.do-not-translate',
    defaultMessage: '⇧',
    description: 'The abbreviated symbol for the Shift key on a keyboard.',
  },
  'whiteboards.shortcuts.H.do-not-translate': {
    id: 'whiteboards.shortcuts.H.do-not-translate',
    defaultMessage: 'H',
    description:
      'The letter H, capitalised, representing a shortcut which brings up the hand tool',
  },
  'whiteboards.shortcuts.V.do-not-translate': {
    id: 'whiteboards.shortcuts.V.do-not-translate',
    defaultMessage: 'V',
    description:
      'The letter V, capitalised, representing a shortcut which brings up the select tool',
  },
  'whiteboards.shortcuts.K.do-not-translate': {
    id: 'whiteboards.shortcuts.K.do-not-translate',
    defaultMessage: 'K',
    description:
      'The letter K, capitalised, representing a shortcut which brings up the link picker',
  },
  'whiteboards.shortcuts.S.do-not-translate': {
    id: 'whiteboards.shortcuts.S.do-not-translate',
    defaultMessage: 'S',
    description:
      'The letter S, capitalised, representing a shortcut which brings up the sticky note tool',
  },
  'whiteboards.shortcuts.P.do-not-translate': {
    id: 'whiteboards.shortcuts.P.do-not-translate',
    defaultMessage: 'P',
    description:
      'The letter P, capitalised, representing a shortcut which brings up the pen tool',
  },
  'whiteboards.shortcuts.T.do-not-translate': {
    id: 'whiteboards.shortcuts.T.do-not-translate',
    defaultMessage: 'T',
    description:
      'The letter T, capitalised, representing a shortcut which brings up the text box tool',
  },
  'whiteboards.shortcuts.O.do-not-translate': {
    id: 'whiteboards.shortcuts.O.do-not-translate',
    defaultMessage: 'O',
    description:
      'The letter O, capitalised, representing a shortcut which brings up the ellipse tool',
  },
  'whiteboards.shortcuts.R.do-not-translate': {
    id: 'whiteboards.shortcuts.R.do-not-translate',
    defaultMessage: 'R',
    description:
      'The letter R, capitalised, representing a shortcut which brings up the rectangle tool',
  },
  'whiteboards.shortcuts.L.do-not-translate': {
    id: 'whiteboards.shortcuts.L.do-not-translate',
    defaultMessage: 'L',
    description:
      'The letter L, capitalised, representing a shortcut which brings up the line tool',
  },
  'whiteboards.shortcuts.G.do-not-translate': {
    id: 'whiteboards.shortcuts.G.do-not-translate',
    defaultMessage: 'G',
    description:
      'The letter G, capitalised, representing a shortcut which groups selected elements',
  },
  'whiteboards.shortcuts.arrows.do-not-translate': {
    id: 'whiteboards.shortcuts.arrows.do-not-translate',
    defaultMessage: '←→↑↓',
    description: 'The four arrow keys on a keyboard',
  },
  'whiteboards.shortcuts.arrow-left.do-not-translate': {
    id: 'whiteboards.shortcuts.arrow-left.do-not-translate',
    defaultMessage: '←',
    description: 'The left arrow key on a keyboard',
  },
  'whiteboards.shortcuts.arrow-right.do-not-translate': {
    id: 'whiteboards.shortcuts.arrow-right.do-not-translate',
    defaultMessage: '→',
    description: 'The right arrow key on a keyboard',
  },

  'whiteboards.shortcuts.arrow-up.do-not-translate': {
    id: 'whiteboards.shortcuts.arrow-up.do-not-translate',
    defaultMessage: '↑',
    description: 'The up arrow key on a keyboard',
  },
  'whiteboards.shortcuts.arrow-down.do-not-translate': {
    id: 'whiteboards.shortcuts.arrow-down.do-not-translate',
    defaultMessage: '↓',
    description: 'The down arrow key on a keyboard',
  },
  'whiteboards.shortcuts.zoom-in.do-not-translate': {
    id: 'whiteboards.shortcuts.zoom-in.do-not-translate',
    defaultMessage: '+',
    description:
      'The plus key on a keyboard, which is the shortcut for zooming into the whiteboard',
  },
  'whiteboards.shortcuts.zoom-out.do-not-translate': {
    id: 'whiteboards.shortcuts.zoom-out.do-not-translate',
    defaultMessage: '-',
    description:
      'The minus key on a keyboard, which is the shortcut for zooming out of the whiteboard',
  },
  'whiteboards.shortcuts.zoom-reset.do-not-translate': {
    id: 'whiteboards.shortcuts.zoom-reset.do-not-translate',
    defaultMessage: '0',
    description:
      'The zero key on a keyboard, which is the shortcut for resetting the zoom of the whiteboard',
  },
  'whiteboards.shortcuts.zoom-to-fit.do-not-translate': {
    id: 'whiteboards.shortcuts.zoom-to-fit.do-not-translate',
    defaultMessage: '1',
    description:
      'The one key on a keyboard, which is the shortcut for zooming to fit the whiteboard',
  },
  'whiteboards.shortcuts.zoom-to-selection.do-not-translate': {
    id: 'whiteboards.shortcuts.zoom-to-selection.do-not-translate',
    defaultMessage: '2',
    description:
      'The two key on a keyboard, which is the shortcut for zooming to the selection on the whiteboard',
  },
  'whiteboards.shortcuts.undo.do-not-translate': {
    id: 'whiteboards.shortcuts.undo.do-not-translate',
    defaultMessage: 'Z',
    description:
      'The letter Z, capitalised, which is the shortcut for undoing the last action',
  },
  'whiteboards.shortcuts.redo.do-not-translate': {
    id: 'whiteboards.shortcuts.redo.do-not-translate',
    defaultMessage: 'Z',
    description:
      'The letter Z, capitalised, which is the shortcut for redoing the last action',
  },
  'whiteboards.shortcuts.copy.do-not-translate': {
    id: 'whiteboards.shortcuts.copy.do-not-translate',
    defaultMessage: 'C',
    description:
      'The letter C, capitalised, which is the shortcut for copying the current selection',
  },
  'whiteboards.shortcuts.paste.do-not-translate': {
    id: 'whiteboards.shortcuts.paste.do-not-translate',
    defaultMessage: 'V',
    description:
      'The letter V, capitalised, which is the shortcut for pasting the current selection',
  },
  'whiteboards.shortcuts.cut.do-not-translate': {
    id: 'whiteboards.shortcuts.cut.do-not-translate',
    defaultMessage: 'X',
    description:
      'The letter X, capitalised, which is the shortcut for cutting (ie deleting) the current selection',
  },
  'whiteboards.shortcuts.duplicate.do-not-translate': {
    id: 'whiteboards.shortcuts.duplicate.do-not-translate',
    defaultMessage: 'D',
    description:
      'The letter D, capitalised, which is the shortcut for duplicating the current selection',
  },
  'whiteboards.shortcuts.delete.do-not-translate': {
    id: 'whiteboards.shortcuts.delete.do-not-translate',
    defaultMessage: 'Delete',
    description:
      'The delete key on a keyboard, which is the shortcut for deleting the current selection',
  },
  'whiteboards.shortcuts.select-all.do-not-translate': {
    id: 'whiteboards.shortcuts.select-all.do-not-translate',
    defaultMessage: 'A',
    description:
      'The letter A, capitalised, which is the shortcut for selecting all items on the whiteboard',
  },
  'whiteboards.shortcuts.lock.do-not-translate': {
    id: 'whiteboards.shortcuts.lock.do-not-translate',
    defaultMessage: 'L',
    description:
      'The letter L, capitalised, which is the shortcut for locking the current selection',
  },
  'whiteboards.shortcuts.create-jira-issue.do-not-translate': {
    id: 'whiteboards.shortcuts.create-jira-issue.do-not-translate',
    defaultMessage: 'J',
    description:
      'The letter J, capitalised, which is the shortcut for creating a Jira issue from the current selection',
  },
  'whiteboards.shortcuts.bring-to-front.do-not-translate': {
    id: 'whiteboards.shortcuts.bring-to-front.do-not-translate',
    defaultMessage: ']',
    description:
      'The left square bracket key on a keyboard, which is the shortcut for bringing the current selection to the front',
  },
  'whiteboards.shortcuts.bring-to-front-alt.do-not-translate': {
    id: 'whiteboards.shortcuts.bring-to-front-alt.do-not-translate',
    defaultMessage: 'F',
    description:
      'The letter F, capitalised, which is the shortcut for bringing the current selection to the front',
  },
  'whiteboards.shortcuts.send-to-back.do-not-translate': {
    id: 'whiteboards.shortcuts.send-to-back.do-not-translate',
    defaultMessage: '[',
    description:
      'The right square bracket key on a keyboard, which is the shortcut for sending the current selection to the back',
  },
  'whiteboards.shortcuts.send-to-back-alt.do-not-translate': {
    id: 'whiteboards.shortcuts.send-to-back-alt.do-not-translate',
    defaultMessage: 'B',
    description:
      'The letter B, capitalised, which is the shortcut for sending the current selection to the back',
  },
  'whiteboards.shortcuts.bold.do-not-translate': {
    id: 'whiteboards.shortcuts.bold.do-not-translate',
    defaultMessage: 'B',
    description:
      'The letter B, capitalised, which is the shortcut for bolding the current selection',
  },
  'whiteboards.shortcuts.italic.do-not-translate': {
    id: 'whiteboards.shortcuts.italic.do-not-translate',
    defaultMessage: 'I',
    description:
      'The letter I, capitalised, which is the shortcut for italicising the current selection',
  },
  'whiteboards.shortcuts.underline.do-not-translate': {
    id: 'whiteboards.shortcuts.underline.do-not-translate',
    defaultMessage: 'U',
    description:
      'The letter U, capitalised, which is the shortcut for underlining the current selection',
  },

  'whiteboards.shortcuts.modal.do-not-translate': {
    id: 'whiteboards.shortcuts.modal.do-not-translate',
    defaultMessage: '/',
    description:
      'The character /, which is the shortcut for opening the shortcuts help modal',
  },
  'whiteboards.shortcuts.fullscreen-enter.do-not-translate': {
    id: 'whiteboards.shortcuts.fullscreen-enter.do-not-translate',
    defaultMessage: 'F',
    description:
      'The letter F, capitalised, which is the shortcut for entering full screen mode',
  },
  'whiteboards.shortcuts.fullscreen-exit.do-not-translate': {
    id: 'whiteboards.shortcuts.fullscreen-exit.do-not-translate',
    defaultMessage: 'Esc',
    description: 'The abbreviated name of the Escape key on a keyboard',
  },
  'whiteboards.shortcuts.title.sticky-tool': {
    id: 'whiteboards.shortcuts.title.sticky-tool',
    defaultMessage: 'Sticky tool',
    description: 'The title of the sticky tool shortcut, used to create sticky notes',
  },
  'whiteboards.shortcuts.title.card-tool': {
    id: 'whiteboards.shortcuts.title.card-tool',
    defaultMessage: 'Card tool',
    description: 'The title of the card tool shortcut, used to create cards',
  },
  'whiteboards.shortcuts.title.drawing-tool': {
    id: 'whiteboards.shortcuts.title.drawing-tool',
    defaultMessage: 'Pen tool',
    description: 'The title of the pen tool shortcut, used to create drawings',
  },
  'whiteboards.shortcuts.title.text-box-tool': {
    id: 'whiteboards.shortcuts.title.text-box-tool',
    defaultMessage: 'Text box tool',
    description: 'The title of the text box tool shortcut, used to create text boxes',
  },
  'whiteboards.shortcuts.title.ellipse-tool': {
    id: 'whiteboards.shortcuts.title.ellipse-tool',
    defaultMessage: 'Ellipse tool',
    description: 'The title of the ellipse tool shortcut, used to create ellipses',
  },
  'whiteboards.shortcuts.title.rectangle-tool': {
    id: 'whiteboards.shortcuts.title.rectangle-tool',
    defaultMessage: 'Rectangle tool',
    description: 'The title of the rectangle tool shortcut, used to create rectangles',
  },
  'whiteboards.shortcuts.title.line-tool': {
    id: 'whiteboards.shortcuts.title.line-tool',
    defaultMessage: 'Line tool',
    description: 'The title of the line tool shortcut, used to create lines',
  },
  'whiteboards.shortcuts.title.zoom-in': {
    id: 'whiteboards.shortcuts.title.zoom-in',
    defaultMessage: 'Zoom in',
    description: 'The title of the zoom in shortcut, used to zoom in on the whiteboard',
  },
  'whiteboards.shortcuts.title.zoom-out': {
    id: 'whiteboards.shortcuts.title.zoom-out',
    defaultMessage: 'Zoom out',
    description: 'The title of the zoom out shortcut, used to zoom out of the whiteboard',
  },
  'whiteboards.shortcuts.title.zoom-to-100%': {
    id: 'whiteboards.shortcuts.title.zoom-to-100%',
    defaultMessage: 'Zoom to 100%',
    description:
      'The title of the zoom to 100% shortcut, used to zoom to 100% on the whiteboard',
  },
  'whiteboards.shortcuts.title.zoom-to-fit': {
    id: 'whiteboards.shortcuts.title.zoom-to-fit',
    defaultMessage: 'Zoom to fit',
    description:
      'The title of the zoom to fit shortcut, used to zoom to fit all the elements on the whiteboard',
  },
  'whiteboards.shortcuts.title.zoom-to-selection': {
    id: 'whiteboards.shortcuts.title.zoom-to-selection',
    defaultMessage: 'Zoom to selection',
    description:
      'The title of the zoom to selection shortcut, used to zoom to the current selection',
  },
  'whiteboards.shortcuts.title.move-whiteboard': {
    id: 'whiteboards.shortcuts.title.move-whiteboard',
    defaultMessage: 'Move whiteboard',
    description: 'The title of the move whiteboard shortcut',
  },
  'whiteboards.shortcuts.title.cancel': {
    id: 'whiteboards.shortcuts.title.cancel',
    defaultMessage: 'Cancel',
    description: 'The title of the cancel shortcut',
  },
  'whiteboards.shortcuts.title.hand-tool': {
    id: 'whiteboards.shortcuts.title.hand-tool',
    defaultMessage: 'Hand tool',
    description:
      'The title of the hand tool shortcut, used to move the whiteboard around',
  },
  'whiteboards.shortcuts.title.select-tool': {
    id: 'whiteboards.shortcuts.title.select-tool',
    defaultMessage: 'Select tool',
    description:
      'The title of the select tool shortcut, used to select elements on the whiteboard',
  },
  'whiteboards.shortcuts.title.link': {
    id: 'whiteboards.shortcuts.title.link',
    defaultMessage: 'Add a link',
    description: 'The title of the link shortcut, used to create links',
  },
  'whiteboards.shortcuts.title.section': {
    id: 'whiteboards.shortcuts.title.section',
    defaultMessage: 'Section',
    description: 'The title of the section shortcut, used to create sections',
  },
  'whiteboards.shortcuts.title.copy': {
    id: 'whiteboards.shortcuts.title.copy',
    defaultMessage: 'Copy',
    description: 'The title of the copy shortcut, used to copy the current selection',
  },
  'whiteboards.shortcuts.title.cut': {
    id: 'whiteboards.shortcuts.title.cut',
    defaultMessage: 'Cut',
    description: 'The title of the cut shortcut, used to delete the current selection',
  },
  'whiteboards.shortcuts.title.paste': {
    id: 'whiteboards.shortcuts.title.paste',
    defaultMessage: 'Paste',
    description: 'The title of the paste shortcut, to paste from the clipboard',
  },
  'whiteboards.shortcuts.title.duplicate': {
    id: 'whiteboards.shortcuts.title.duplicate',
    defaultMessage: 'Duplicate',
    description:
      'The title of the duplicate shortcut, used to duplicate the current selection',
  },
  'whiteboards.shortcuts.title.delete': {
    id: 'whiteboards.shortcuts.title.delete',
    defaultMessage: 'Delete',
    description: 'The title of the delete shortcut, used to delete the current selection',
  },
  'whiteboards.shortcuts.title.select-all': {
    id: 'whiteboards.shortcuts.title.select-all',
    defaultMessage: 'Select all',
    description: 'The title of the select all shortcut, used to select all elements',
  },
  'whiteboards.shortcuts.title.undo': {
    id: 'whiteboards.shortcuts.title.undo',
    defaultMessage: 'Undo',
    description: 'The title of the undo shortcut, used to undo the previous changes',
  },
  'whiteboards.shortcuts.title.redo': {
    id: 'whiteboards.shortcuts.title.redo',
    defaultMessage: 'Redo',
    description:
      'The title of the redo shortcut, used to put back previously undone changes',
  },
  'whiteboards.shortcuts.title.lock-/-unlock': {
    id: 'whiteboards.shortcuts.title.lock-/-unlock',
    defaultMessage: 'Lock / Unlock',
    description:
      'The title of the Lock / Unlock shortcut, toggling the lock of the selection',
  },
  'whiteboards.shortcuts.title.nudge-element': {
    id: 'whiteboards.shortcuts.title.nudge-element',
    defaultMessage: 'Nudge element',
    description:
      'The title of the nudge element shortcut, used to slightly move the selection',
  },
  'whiteboards.shortcuts.title.big-nudge-element': {
    id: 'whiteboards.shortcuts.title.big-nudge-element',
    defaultMessage: 'Big nudge element',
    description:
      'The title of the big nudge element shortcut, used to move the selection',
  },
  'whiteboards.shortcuts.title.big-nudge-element-left': {
    id: 'whiteboards.shortcuts.title.big-nudge-element-left',
    defaultMessage: 'Big nudge element left',
    description: 'The title of the big nudge element left shortcut',
  },
  'whiteboards.shortcuts.title.big-nudge-element-right': {
    id: 'whiteboards.shortcuts.title.big-nudge-element-right',
    defaultMessage: 'Big nudge element right',
    description: 'The title of the big nudge element right shortcut',
  },
  'whiteboards.shortcuts.title.big-nudge-element-up': {
    id: 'whiteboards.shortcuts.title.big-nudge-element-up',
    defaultMessage: 'Big nudge element up',
    description: 'The title of the big nudge element up shortcut',
  },
  'whiteboards.shortcuts.title.big-nudge-element-down': {
    id: 'whiteboards.shortcuts.title.big-nudge-element-down',
    defaultMessage: 'Big nudge element down',
    description: 'The title of the big nudge element down shortcut',
  },
  'whiteboards.shortcuts.title.create-jira-issue': {
    id: 'whiteboards.shortcuts.title.create-jira-issue',
    defaultMessage: 'Create Jira issue',
    description: 'The title of the create Jira issue shortcut',
  },
  'whiteboards.shortcuts.title.create-jira-issue-issue-terminology-refresh-m4': {
    id: 'whiteboards.shortcuts.title.create-jira-issue-issue-terminology-refresh-m4',
    defaultMessage: 'Create Jira work item',
    description: 'The title of the create Jira issue shortcut',
  },
  'whiteboards.shortcuts.title.bring-to-front': {
    id: 'whiteboards.shortcuts.title.bring-to-front',
    defaultMessage: 'Bring to front',
    description: 'The title of the bring to front shortcut',
  },
  'whiteboards.shortcuts.title.send-to-back': {
    id: 'whiteboards.shortcuts.title.send-to-back',
    defaultMessage: 'Send to back',
    description: 'The title of the send to back shortcut',
  },
  'whiteboards.shortcuts.title.toggle-ui': {
    id: 'whiteboards.shortcuts.title.toggle-ui',
    defaultMessage: 'Show / hide UI',
    description: 'Show or hide the UI',
  },
  'whiteboards.shortcuts.title.toggle-ui-alt': {
    id: 'whiteboards.shortcuts.title.toggle-ui-alt',
    defaultMessage: '.',
    description:
      'The . key on a keyboard, the shortcut for toggling visbility of UI menu elements',
  },
  'whiteboards.shortcuts.title.bold': {
    id: 'whiteboards.shortcuts.title.bold',
    defaultMessage: 'Bold',
    description: 'The title of the bold text shortcut',
  },
  'whiteboards.shortcuts.title.italic': {
    id: 'whiteboards.shortcuts.title.italic',
    defaultMessage: 'Italic',
    description: 'The title of the italic text shortcut',
  },
  'whiteboards.shortcuts.title.underline': {
    id: 'whiteboards.shortcuts.title.underline',
    defaultMessage: 'Underline',
    description: 'The title of the underline text shortcut',
  },
  'whiteboards.shortcuts.title.help-modal': {
    id: 'whiteboards.shortcuts.title.help-modal',
    defaultMessage: 'Help Modal',
    description: 'The title of the help modal shortcut',
  },
  'whiteboards.shortcuts.title.fullscreen-enter': {
    id: 'whiteboards.shortcuts.title.fullscreen-enter',
    defaultMessage: 'Enter full screen',
    description: 'The title of the enter full screen shortcut',
  },
  'whiteboards.shortcuts.title.fullscreen-exit': {
    id: 'whiteboards.shortcuts.title.fullscreen-exit',
    defaultMessage: 'Exit full screen',
    description: 'The title of the exit full screen shortcut',
  },
  'whiteboards.shortcuts.title.noop.do-not-translate': {
    id: 'whiteboards.shortcuts.title.noop.do-not-translate',
    defaultMessage: '',
    description: 'An empty string, should not be shown',
  },
});
